import { ComponentType } from 'react';
import ArticlesBase from '@/creditflowresearch/ui/components/creditFlow/articles/Articles';
import { withArticlesConfig } from '@/creditflowresearch/ui/components/creditFlow/articles/withArticlesConfig';
import {
  useEmergingMarketArticlesConfig,
} from '@/creditflowresearch/ui/components/creditFlow/articles/config/adapters';
import { IMarketArticlesData } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IMarketArticle';

interface ICorporateMarketArticlesProps {
  articlesData: IMarketArticlesData,
}

export const EmergingMarketArticles: ComponentType<ICorporateMarketArticlesProps> = withArticlesConfig(
  ArticlesBase,
  useEmergingMarketArticlesConfig,
);

export default EmergingMarketArticles;
